import { useMsal } from "@azure/msal-react";
import {
    Box, Button, CircularProgress, Container, FormControl, Grid, Paper, Step, StepConnector, StepIconProps, StepLabel, Stepper, styled, TextField, Typography
} from "@material-ui/core";
import { CheckCircle, Error, ExitToApp } from '@material-ui/icons';
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { globalStyles } from "../../assets/globalStyles";
import { emptyAktiverMesspunkt } from "../geraetemanagement/geraeteManagementSlice";
import { getAktiveMesspunkte, getKommunkation, selectAktiveMesspunkte, selectKommunikation, selectMesspunkt, selectMesspunktLoading, selectSelectedAktiverMesspunkt, selectSelectedUW, setSelectedUW } from "./datenflussSlice";
import { useStyles } from "./datenflussStyles";

export const Datenfluss: React.FC = () => {
    const dispatch = useAppDispatch();

    const { instance } = useMsal();

    useEffect(() => {
        dispatch(getAktiveMesspunkte());
        dispatch(getKommunkation());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const [uwSelectInputValue, setUwSelectInputValue] = React.useState("");
    const [messpunktSelectInputValue, setMesspunktSelectInputValue] = React.useState("");

    const selectedUW = useAppSelector(selectSelectedUW);
    const aktiveMesspunkte = useAppSelector(selectAktiveMesspunkte);
    const selectedAktiverMesspunkt = useAppSelector(selectSelectedAktiverMesspunkt);
    const messpunktLoading = useAppSelector(selectMesspunktLoading);
    const kommunkation = useAppSelector(selectKommunikation);

    const QontoConnector = styled(StepConnector)(({ theme }) => ({
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.grey[400],
            borderTopWidth: 3,
            borderRadius: 1,
        },
        '&.MuiStepper-root .MuiStep-active': {
            borderColor: "green",
            '& .MuiStepConnector-line': {
                borderColor: "green",
            }
        },
        '&.MuiStep-completed': {
            borderColor: "green",
            '& .MuiStepConnector-completed': {
                borderColor: "green",
                '& .MuiStepConnector-line': {
                    borderColor: "green",
                }
            }
        }
    }));

    const QontoStepIconRoot = styled('div')(
        ({ theme }) => ({
            color: theme.palette.grey[400],
            display: 'flex',
            height: 22,
            alignItems: 'center',
            '& .QontoStepIcon-completedIcon': {
                color: "green",
                zIndex: 1,
                width: 25,
                height: 25,
                fontSize: 18,
            },
            '& .QontoStepIcon-circle': {
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: 'currentColor',
            },
            '& .QontoStepIcon-error': {
                color: theme.palette.error.main,
                zIndex: 1,
                width: 25,
                height: 25,
                fontSize: 18,
            },
        }),
    );

    function QontoStepIcon(props: StepIconProps) {
        const { active, completed, className } = props;

        return (
            <QontoStepIconRoot className={className}>
                {active ? (
                    <Error className="QontoStepIcon-error" />) :
                    [completed ? (
                        <CheckCircle className="QontoStepIcon-completedIcon" />
                    ) : (
                        <div className="QontoStepIcon-circle" />
                    )]}
            </QontoStepIconRoot>
        );
    }

    const steps = [
        { label: 'Messgerät', description: "WinPQ" },
        { label: 'Router', description: "icom Connectivity Suite", url: "https://connectivity.insys-icom.de/insysgui/login?url=https:%2f%2fconnectivity.insys-icom.de%2fhorde%2flogin.php" },
        { label: 'IP@UW', description: "Verantwortlichkeit 3" },
        { label: "BIT", description: "Verantwortlichkeit 4" },
        { label: "TransnetBW (AWS) Cloud", description: "Verantwortlichkeit 5" }];

    const [skipped] = React.useState(new Set<number>());
    const [failed, setFailed] = React.useState<Array<number>>([]);

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };

    const isStepFailed = (step: number) => {
        let stepBeschreibung = "";
        switch (step) {
            case 0:
                stepBeschreibung = "Schreibvorgang in Datenbank";
                break;
            case 1:
                stepBeschreibung = "Schreibvorgang in Datenbank";
                break;
            case 2:
                stepBeschreibung = "Schreibvorgang in Datenbank";
                break;
            case 3:
                stepBeschreibung = "Schreibvorgang in Datenbank";
                break;
            case 4:
                stepBeschreibung = "Durchlauf des DataCollectors";
                break;
            default:
                stepBeschreibung = "";
                break;
        }
        if (kommunkation.filter(x => (x.messstelle == selectedAktiverMesspunkt.name || x.messstelle == null) && x.beschreibung == stepBeschreibung && x.status == 0).length == 0) {
            if (!failed.includes(step)) setFailed(failed.concat([step]));
            return true;
        } else {
            if (failed.includes(step)) setFailed(failed.filter(x => x != step));
            return false;
        }
    };

    // function stepperDatenfluss() {
    //     return (
    //         <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
    //             <Grid item md={12} >
    //                 <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
    //                     Datenfluss Status
    //                 </Typography>
    //             </Grid>
    //             <Grid item md={12} >
    //                 <Box style={{ width: "100%" }}>
    //                     <Stepper alternativeLabel activeStep={2} connector={<QontoConnector />}>
    //                         {steps.map((step, index) => {
    //                             const stepProps: { completed?: boolean } = {};
    //                             const labelProps: {
    //                                 optional?: React.ReactNode;
    //                                 error?: boolean;
    //                             } = {};
    //                             if (isStepFailed(index)) {
    //                                 // labelProps.optional = (
    //                                 //     <Typography color="error">
    //                                 //         Störung
    //                                 //     </Typography>
    //                                 // );
    //                                 labelProps.error = true;
    //                             }
    //                             return (
    //                                 <Step key={step.label}>
    //                                     <StepLabel StepIconComponent={QontoStepIcon} {...labelProps} >
    //                                         <Grid >
    //                                             <Typography variant="h6">
    //                                                 {step.label}
    //                                             </Typography>
    //                                         </Grid>
    //                                         <Grid style={{ marginTop: "20px" }}>
    //                                             <Button variant="text" color="primary" startIcon={<ExitToApp />}>
    //                                                 {step.description}
    //                                             </Button>
    //                                         </Grid>

    //                                     </StepLabel>

    //                                 </Step>
    //                             );
    //                         })}
    //                     </Stepper>
    //                 </Box>
    //             </Grid>
    //         </Paper>
    //     );
    // }

    function stepperDatenfluss() {
        return (
            <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
                <Grid item md={12} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                        Status Datenfluss
                    </Typography>
                </Grid>
                <Grid item md={12} >
                    <Box style={{ width: "100%" }}>
                        <Stepper alternativeLabel activeStep={Math.min(...failed)} connector={<QontoConnector />}>
                            {steps.map((step, index) => {
                                const stepProps: { completed?: boolean } = {};
                                const labelProps: {
                                    optional?: React.ReactNode;
                                    error?: boolean;
                                } = {};
                                if (isStepFailed(index)) {
                                    labelProps.optional = (
                                        <Typography color="error">
                                            Mögliche Störungsursache
                                        </Typography>
                                    );
                                    labelProps.error = true;
                                }
                                if (isStepSkipped(index)) {
                                    stepProps.completed = false;
                                }
                                return (
                                    <Step key={step.label}>
                                        <StepLabel StepIconComponent={QontoStepIcon} {...labelProps} >
                                            <Grid >
                                                <Typography variant="h6">
                                                    {step.label}
                                                </Typography>
                                            </Grid>
                                        </StepLabel>
                                        <Grid style={{ marginTop: "20px" }}>
                                            <Button variant="text" color="primary" startIcon={<ExitToApp />} href={isValidHttpUrl(step.url ?? "")}>
                                                {step.description}
                                            </Button>
                                        </Grid>

                                    </Step>
                                );
                            })}
                        </Stepper>
                    </Box>
                </Grid>
            </Paper>
        );
    }
    function isValidHttpUrl(urlString: string) {
        let url;

        try {
            url = new URL(urlString);
        } catch (_) {
            return "";
        }

        return url.protocol === "http:" || url.protocol === "https:" ? urlString : "";
    }
    function printMesspunktauswahl() {
        return (
            <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
                <Grid item md={3} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "16px" }} >
                        Auswahl aktiver Messpunkt
                    </Typography>
                </Grid>
                <FormControl className={classes.fullWidth}>
                    <Grid container item style={{ paddingRight: "16px" }}>
                        <Grid item md={6} style={{ paddingRight: "20px", textAlign: "right" }}>
                            <FormControl
                                className={classes.formControlAutoComplete}
                            >
                                <Autocomplete
                                    id="select-uw"
                                    value={selectedUW}
                                    noOptionsText={<React.Fragment>
                                        {messpunktLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Umspannwerke"}
                                    </React.Fragment>}
                                    onChange={(event, newValue) => { dispatch(setSelectedUW(newValue ? newValue : "")); setMesspunktSelectInputValue(""); dispatch(selectMesspunkt(emptyAktiverMesspunkt)); }}
                                    inputValue={uwSelectInputValue}
                                    onInputChange={(event, newInputValue) => setUwSelectInputValue(newInputValue)}
                                    options={[...new Set(aktiveMesspunkte.map((e) => e.umspannwerk))]}
                                    getOptionLabel={(option) => (option ? option : "")}
                                    renderInput={(params) => <TextField {...params}
                                        label="Umspannwerk"
                                        variant="outlined"
                                    />}
                                    className={classes.selectEmpty}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md={6}>
                            <FormControl
                                className={classes.formControlAutoComplete}
                            >
                                <Autocomplete
                                    id="select-messpunkt"
                                    value={selectedAktiverMesspunkt}
                                    noOptionsText={<React.Fragment>
                                        {messpunktLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine aktiven Messpunkte"}</React.Fragment>}
                                    onChange={(event, newValue) => {
                                        const a = aktiveMesspunkte.filter(e => e.name === newValue?.name);
                                        dispatch(selectMesspunkt(a.length > 0 ? a[0] : emptyAktiverMesspunkt));
                                    }
                                    }
                                    inputValue={messpunktSelectInputValue}
                                    onInputChange={(event, newInputValue) => {
                                        setMesspunktSelectInputValue(newInputValue);
                                    }}
                                    options={aktiveMesspunkte.filter((e) => e.umspannwerk === selectedUW)}
                                    getOptionLabel={(option) => (option.name != "" ? (option.schaltfeld + " (" + option.name + ")") : "")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Messpunkt"
                                            variant="outlined"
                                        />
                                    )}
                                    disabled={selectedUW == ""}
                                    className={classes.selectEmpty}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </FormControl>
            </Paper>
        );
    }

    return (
        <div>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Übersicht Datenfluss
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            {printMesspunktauswahl()}
            {selectedAktiverMesspunkt != emptyAktiverMesspunkt ? stepperDatenfluss() : ""}
        </div>
    );
}